import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';

interface ProfileMenuProps {
  profile: {
    username: string;
    userId: string;
  };
  profileImageUrl: string;
  onImageError: (event: React.SyntheticEvent<HTMLImageElement>) => void;
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Profile dropdown menu component for desktop header.
 * Displays user profile picture and dropdown with Account/Sign Out links.
 */
export const ProfileMenu = ({ profile, profileImageUrl, onImageError }: ProfileMenuProps) => {
  return (
    <Menu as="div" className="relative">
      <div>
        <Menu.Button
          className="max-w-xs bg-surface flex items-center text-sm rounded-full
                        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <span className="sr-only">Open user menu</span>
          <div>
            <img
              className="max-w-full w-10 h-10 rounded-full object-cover"
              alt={profile.username}
              title={profile.username}
              src={profileImageUrl}
              loading="eager"
              // @ts-ignore
              fetchpriority="high"
              onError={onImageError}
            />
          </div>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="origin-top-right absolute right-0 mt-2 w-48
                        rounded-md shadow-lg py-1 bg-surface ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <Menu.Item>
            {({ active }) => (
              <Link
                to={'/account'}
                className={classNames(
                  active ? 'bg-muted' : '',
                  'block px-4 py-2 text-sm text-main',
                )}
              >
                Account
              </Link>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <Link
                to={'/signout'}
                className={classNames(
                  active ? 'bg-muted' : '',
                  'block px-4 py-2 text-sm text-main',
                )}
              >
                Sign Out
              </Link>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
